module.exports = __webpack_public_path__ + "static/media/logo_rimeim.13a695bd.png";